import { render } from "./View.vue?vue&type=template&id=4dd5a1cc&scoped=true"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"

import "./View.vue?vue&type=style&index=0&id=4dd5a1cc&lang=less&scoped=true"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd5a1cc"]])

export default __exports__